__turbopack_context__.v({
  "empty": "community-showcase-module-scss-module__MGf9Da__empty",
  "grid": "community-showcase-module-scss-module__MGf9Da__grid",
  "inner": "community-showcase-module-scss-module__MGf9Da__inner",
  "reveal": "community-showcase-module-scss-module__MGf9Da__reveal",
  "reveal-mobile-only": "community-showcase-module-scss-module__MGf9Da__reveal-mobile-only",
  "showcase": "community-showcase-module-scss-module__MGf9Da__showcase",
});
